/** @format */

import React, { useState } from 'react'
import { _$, Tabs, Tab, Card } from '@king-design/react'
import { useLocation } from 'react-router-dom'
import TacticsList from 'src/containers/MonitorAlarmTactics/TacticsList'
import EventList from 'src/containers/MonitorAlarmTactics/AlarmEventList'
import styled from 'styled-components'
import { CustomPageContainer } from 'src/components'

// 告警策略
const TacticsTabs = [
  {
    text: _$('阈值告警'),
    value: 'threshold'
  },
  {
    text: _$('事件告警'),
    value: 'event'
  }
]
const MonitorAlarmTactics: React.FC<{ className?: string }> = ({ className }) => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const tab = searchParams.get('tab')
  const [currentTab, setTab] = useState(tab || 'threshold')

  return (
    <div className={className}>
      <CustomPageContainer
        title={_$('告警策略')}
        content={
          <Tabs
            value={currentTab}
            onChangeValue={tab => {
              setTab(tab)
              window.history.pushState(null, '', `/#!/monitor/alarmServer/rule/home?tab=${tab}`)
            }}
          >
            {TacticsTabs.map(({ text, value }) => (
              <Tab key={value} value={value}>
                {_$(text)}
              </Tab>
            ))}
          </Tabs>
        }
      >
        <Card type="none">
          <div>{currentTab === 'threshold' ? <TacticsList /> : null}</div>
          <div>{currentTab === 'event' ? <EventList /> : null}</div>
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(MonitorAlarmTactics)`
  .custom-page-header {
    padding-bottom: 0;
  }
`
